export default __webpack_public_path__ + "static/customers-meta-7568cd430882fe718df958fbf6a8134a.png";